'use strict';

export { default } from './tableWrapper.component';